<template>
  <div class="user-section">
    <p class="user-section__title">Add a new User</p>
    <form action class="user-form">
      <div class="user-form__row">
        <label for="usersName" class="user-form__label">Username</label>
        <fg-input name="usersName" v-model="username"></fg-input>
      </div>
      <div class="user-form__row">
        <label for="password" class="user-form__label">Password</label>
        <fg-input name="password" type="password" v-model="password"></fg-input>
      </div>
      <div class="user-form__row">
        <label for="firstName" class="user-form__label">First name</label>
        <fg-input name="firstName" v-model="first_name"></fg-input>
      </div>
      <div class="user-form__row">
        <label for="lastName" class="user-form__label">Last name</label>
        <fg-input name="lastName" v-model="last_name"></fg-input>
      </div>
      <div class="user-form__row">
        <label for="email" class="user-form__label">E-mail</label>
        <fg-input name="email" v-model="email"></fg-input>
      </div>
      <p-button
        size="sm"
        type="submit"
        style="line-height: 2.4;"
        @click.native="submitUsersForm"
        >Add</p-button
      >
    </form>
  </div>
</template>
<script>
import EmptyFieldsError from "../../Notifications/EmptyFieldsError";
import CreateUser from "../../Notifications/CreateUser";

export default {
  data() {
    return {
      username: "",
      password: "",
      first_name: "",
      last_name: "",
      email: ""
    };
  },
  methods: {
    submitUsersForm() {
      if (this.username === "") {
        this.$notify({
          component: EmptyFieldsError,
          icon: "ti-alert",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger"
        });
        return;
      }
      let formData = new FormData();
      formData.append("username", this.username);
      formData.append("password", this.password);
      formData.append("first_name", this.first_name);
      formData.append("last_name", this.last_name);
      formData.append("email", this.email);

      this.$store.dispatch("postUser", formData).then(() => {
        this.$notify({
          component: CreateUser,
          icon: "ti-gift",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success"
        });
        this.username = "";
        this.password = "";
        this.first_name = "";
        this.last_name = "";
        this.email = "";
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.user-section {
  &__title {
    border-bottom: 1px solid #dddddd;
    font-size: 20px;
    padding: 5px 0px;
  }
}

.user-form {
  text-align: center;

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__label {
    font-size: 16px;
    font-weight: bold;
    margin-right: 1em;
  }

  &__file-wrapper {
    display: flex;
    width: 211px;
    align-items: center;
  }

  &__choose {
    display: none;
  }

  &__choose-label {
    margin-left: 10px;
    width: 140px;
    margin-bottom: 1rem;
    padding: 9px 3px;
    border-radius: 4px;
    color: white;
    background-color: #66615b;
    cursor: pointer;
  }
}
</style>
